let idleTime = 0;
const maxIdleTime = 120; // 2 minutes in seconds
let timer = null;
let remainingTime = maxIdleTime;

const resetIdleTimer = () => {
  idleTime = 0;
  remainingTime = maxIdleTime;
};

const startIdleTimer = (callback) => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  resetIdleTimer();

  document.removeEventListener('mousemove', resetIdleTimer);
  document.removeEventListener('keypress', resetIdleTimer);
  document.removeEventListener('mousedown', resetIdleTimer);
  document.removeEventListener('touchstart', resetIdleTimer);

  document.addEventListener('mousemove', resetIdleTimer);
  document.addEventListener('keypress', resetIdleTimer);
  document.addEventListener('mousedown', resetIdleTimer);
  document.addEventListener('touchstart', resetIdleTimer);

  timer = setInterval(() => {
    idleTime += 1;
    remainingTime -= 1;
    if (idleTime >= maxIdleTime) {
      clearInterval(timer);
      timer = null;
      if (typeof callback === 'function') {
        callback();
      }
    }
  }, 1000);
};

const stopIdleTimer = () => {
  document.removeEventListener('mousemove', resetIdleTimer);
  document.removeEventListener('keypress', resetIdleTimer);
  document.removeEventListener('mousedown', resetIdleTimer);
  document.removeEventListener('touchstart', resetIdleTimer);
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};

const getRemainingTime = () => remainingTime;

export { startIdleTimer, stopIdleTimer, getRemainingTime };
